import { useMutation } from "@tanstack/react-query";
import { GymListingService } from "../../services/gym-listing.service";

export const useGymListingMutations = () => {
  const { mutate: deleteGymListing } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymListingService.deleteById(id),
  });

  const { mutate: approveGymListing } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymListingService.approveById(id),
  });

  const { mutate: suspendGymListing } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymListingService.suspendById(id),
  });

  const { mutate: unsuspendGymListing } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymListingService.unsuspendById(id),
  });

  const { mutate: enableLastMinuteDeal } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymListingService.enableLastMinuteDeal(id),
  });

  const { mutate: disableLastMinuteDeal } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymListingService.disableLastMinuteDeal(id),
  });

  const { mutate: declineGymListing } = useMutation<
    any,
    Error,
    { id: string; model: { title: string; description: string } }
  >({
    mutationFn: async ({ id, model }) => GymListingService.declineById(id, model),
  });

  return {
    deleteGymListing,
    approveGymListing,
    suspendGymListing,
    unsuspendGymListing,
    declineGymListing,
    enableLastMinuteDeal,
    disableLastMinuteDeal,
  };
};
